import { render, staticRenderFns } from "./PifXgsponInfos.vue?vue&type=template&id=664cda6e&scoped=true&"
import script from "./PifXgsponInfos.vue?vue&type=script&lang=js&"
export * from "./PifXgsponInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664cda6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664cda6e')) {
      api.createRecord('664cda6e', component.options)
    } else {
      api.reload('664cda6e', component.options)
    }
    module.hot.accept("./PifXgsponInfos.vue?vue&type=template&id=664cda6e&scoped=true&", function () {
      api.rerender('664cda6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/eligibility/PifXgsponInfos.vue"
export default component.exports